import kebabCase from 'lodash/kebabCase';
import React from 'react';
import { CallToAction, NonTextLink } from '../../../commonTypes/links';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import { GridItem } from '../../Grid';
import Link from '../../Link';
import ChevronBackground from '../ChevronBackground';
import MarketingPromoBadge from '../MarketingPromoBadge';
import { marketingPromoBadgeGridProps, marketingPromoCopyGridProps } from './layout';
import {
  CtasContainer,
  FinePrint,
  Heading,
  StyledGrid,
  StyledPrimaryCta,
  StyledSecondaryCta,
  Subheading,
} from './styles';

export const marketingPromoId = (heading: string): string =>
  `marketing-promo__${kebabCase(heading)}`;

export type MarketingPromoProps = {
  heading: string;
  subheading: string;
  primaryCta?: CallToAction;
  secondaryCta?: CallToAction;
  finePrint?: string;
  badge: {
    heading: string;
    subheading: string;
  };
} & ComponentProps;

const MarketingPromo: React.FC<MarketingPromoProps> = ({
  heading,
  subheading,
  primaryCta,
  secondaryCta,
  finePrint,
  badge,
  ...props
}) => {
  const badgeLink: NonTextLink | undefined = primaryCta?.url
    ? {
        url: primaryCta.url,
        screenReaderText: primaryCta.screenReaderText,
        onClick: primaryCta.onClick,
      }
    : undefined;
  return (
    <ChevronBackground {...componentProps(props)} id={marketingPromoId(heading)}>
      <StyledGrid>
        <GridItem {...marketingPromoBadgeGridProps}>
          <MarketingPromoBadge {...badge} size="large" link={badgeLink} />
        </GridItem>
        <GridItem {...marketingPromoCopyGridProps}>
          <Heading>
            {primaryCta?.url ? (
              <Link href={primaryCta.url} onClick={primaryCta.onClick} removeVisitedStyle>
                {heading}
              </Link>
            ) : (
              heading
            )}
          </Heading>
          <Subheading>{subheading}</Subheading>
          {(!!primaryCta || !!secondaryCta) && (
            <CtasContainer>
              {primaryCta && <StyledPrimaryCta cta={primaryCta} />}
              {secondaryCta && <StyledSecondaryCta cta={secondaryCta} />}
            </CtasContainer>
          )}
          {finePrint && <FinePrint>{finePrint}</FinePrint>}
        </GridItem>
      </StyledGrid>
    </ChevronBackground>
  );
};

export default applyComponentTheme(MarketingPromo, 'MarketingPromo');
